import { GROUP_OWN_PAGE_LABELS, NAV_CONFIG, NAV_TOP_LEVEL_KEYS, type MenuKey } from "./menu-registry";

/** Hjelp-senteret er aldri RBAC-gatet (VIB-972) og er derfor siste utvei. */
export const HELP_PATH = "/hjelp";

/**
 * VIB-2527: Første side en rolle faktisk har tilgang til, i sidebar-rekkefølge.
 *
 * Brukes som landingsside etter innlogging når rollen ikke har Måltall.
 * Speiler synlighetsregelen i AppLayout: et top-level-punkt teller som
 * tilgjengelig hvis selve nøkkelen er åpen, ellers første åpne barn
 * (f.eks. vanlige ansatte som kun har «innstillinger.varsler»).
 * Ingen treff → Hjelp, som alle roller kan se.
 *
 * Et punkt MED barn er en gruppe i sidebaren, og da styrer nøkkelen om gruppa
 * vises, ikke om forelderens egen path er brukbar. «Innstillinger» er åpen for
 * ALLE roller fordi den personlige Varsler-siden ligger under den, mens
 * /innstillinger selv er admin-flata. Derfor velges barn FØR forelder når det
 * finnes barn: ellers havner en ekstern bruker på /innstillinger, som sender
 * videre til Organisasjon. Har gruppa ingen åpne barn, er den tom og dermed
 * ubrukelig å lande på, så vi går videre til neste punkt. Unntak: grupper der
 * forelderens egen side er en lenke i gruppen (GROUP_OWN_PAGE_LABELS), som
 * Salgsmuligheter (Oppdag og Pipe), lander på forelderen når den er åpen.
 */
export function resolveLandingPath(
  canAccess: (key: MenuKey) => boolean,
  keys: readonly MenuKey[] = NAV_TOP_LEVEL_KEYS,
): string {
  for (const key of keys) {
    const cfg = NAV_CONFIG[key];
    if (!cfg) continue;
    if (cfg.childKeys?.length) {
      // Gruppe der forelderens egen side er en lenke (Salgsmuligheter): forelderen er brukbar.
      if (GROUP_OWN_PAGE_LABELS[key] && canAccess(key)) return cfg.path;
      const child = cfg.childKeys.find((ck) => canAccess(ck));
      if (child) return NAV_CONFIG[child]?.path ?? HELP_PATH;
      continue;
    }
    if (canAccess(key)) return cfg.path;
  }
  return HELP_PATH;
}
